import apis from ".";

export async function validateOTP(emailPhoneNumber, otp) {
  try {
    const result = await apis.post("/validate-otp", {
      emailOrPhone: emailPhoneNumber,
      otp: otp,
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
}

export async function loginWithOTP(emailPhoneNumber, otp) {
  try {
    const result = await apis.post("/login-with-otp", {
      emailOrPhone: emailPhoneNumber,
      otp: otp,
    });

        return result
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}

export async function registerOTP(phoneNumber) {
    try {
        const result = await apis.post('/register-otp', {
            Phone: phoneNumber
        })

        return result
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}

export async function verifyOTP(userId, otp) {
    try {
        const result = await apis.post('/register-otp-verify', {
            UserId: userId,
            otp: otp
        })

        return result
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}
